import React from "react";

const WorkCompIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path
            d="M0.75 17.4167V16.1904C0.750001 14.9987 1.59115 13.9727 2.75971 13.739L5.13137 13.2646C5.3274 13.2254 5.53097 13.2657 5.6973 13.3766L5.70765 13.3835C7.24719 14.4098 9.25286 14.4098 10.7924 13.3835L10.8027 13.3766C10.9691 13.2657 11.1727 13.2254 11.3687 13.2646L13.7403 13.739C14.9089 13.9727 15.75 14.9987 15.75 16.1904V17.4167"
            stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.91667 16.5831V13.3074" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
            <path d="M11.5846 16.5831V13.3074" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
            <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.91536 6.58333H11.582C12.0423 6.58333 12.4154 6.21024 12.4154 5.75V4.91667C12.4154 2.61548 10.5499 0.75 8.2487 0.75V0.75C5.94751 0.75 4.08203 2.61548 4.08203 4.91667V5.75C4.08203 6.21024 4.45513 6.58333 4.91536 6.58333Z"
            stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.66797 6.58317H12.8346" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
            <path
            d="M11.5846 6.58325V8.24951C11.5846 10.0905 10.0923 11.5828 8.2513 11.5828V11.5828C6.41035 11.5828 4.91797 10.0905 4.91797 8.24951V6.58325"
            stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.0017 11.0874L10.6051 13.5011" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
            <path d="M6.4996 11.0874L5.89623 13.501" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
            <path
            d="M6.79297 6.58317V5.12484C6.79297 4.31942 7.44589 3.6665 8.2513 3.6665V3.6665C9.05672 3.6665 9.70964 4.31942 9.70964 5.12484V6.58317"
            stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
    );  
};

    export default WorkCompIcon;